import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "./Components/Common/spectrumCompat";
import { configureStore } from "./Redux/store";
import { getDXPBasePath } from "./Helpers/utils";
import { SpectrumProviderWithRouter } from "./SpectrumProviderWithRouter";
import "./style.css";
import MainContainer from "./Components/App/MainContainer";
import ScrollToTop from "./Components/App/ScrollToTop";

function App() {
  return (
    <Provider store={configureStore()}>
      <BrowserRouter basename={getDXPBasePath()}>
        <SpectrumProviderWithRouter>
          <ScrollToTop />
          <div className="App">
            <MainContainer />
            <ToastContainer placement="top" />
          </div>
        </SpectrumProviderWithRouter>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
